import type { SVGProps } from 'react';
const SvgArrowDownOutlinedSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      fillOpacity={0.88}
      d="M13.813 4H12.64a.25.25 0 0 0-.202.103L8 10.222 3.561 4.103A.25.25 0 0 0 3.36 4H2.188a.125.125 0 0 0-.102.198l5.51 7.596c.2.275.609.275.807 0l5.51-7.596a.124.124 0 0 0-.1-.198"
    />
  </svg>
);
export default SvgArrowDownOutlinedSmall;
